import React from "react";
import { CreativeHistory } from "hooks/api/useCreativeHistory";
import { Link, Typography } from "@material-ui/core";
import { API } from "api";
import { useTranslation } from "react-i18next";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";
import { PrintValidation, Validation } from "pages/MaterialSpecs/components/InfoPanel";

export const ExpandableHistorySelector = ({ sourceType, ...props }: CreativeHistory) => {
    const { t } = useTranslation();
    const { isPrinted } = useMaterialSpecs();

    // if sourceType does not exist look for an error, file path or show nothing...
    if (!sourceType) {
        // why this is an array!?
        const [audit] = props.audits;

        if (audit) {
            if (audit.type === "FileAuditLog") {
                return (
                    <Link href={`${API.serverUrl}${audit.file}`} rel="norefferer" target="_blank">
                        {t("buttons.label.showMore")}
                    </Link>
                );
            }

            // show validation report
            if (audit.type === "LazyFileAuditLog") {
                return isPrinted ? <PrintValidation /> : <Validation simplified showIcons={false} />;
            }

            return (
                <Typography color="error" style={{ wordWrap: "break-word", wordBreak: "break-word" }}>
                    {audit.value}
                </Typography>
            );
        }

        return null;
    }

    const [audit] = props.audits;

    if (audit) {
        // just show audit value
        return <Typography color="textPrimary">{audit.value}</Typography>;
    }

    // for this case source should be always string...?
    return <Typography color="error">{props.source as string}</Typography>;
};
